import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
/**
 * Fixed fullscreen overlay for visualization views.
 * Handles Escape key to close and provides a consistent header layout.
 */ export function VisualizationFullscreenOverlay({ icon: Icon, title, controls, onClose, children }) {
    useEffect(function subscribeToEscapeKey() {
        const handler = (e)=>{
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handler);
        return ()=>document.removeEventListener("keydown", handler);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "fixed inset-0 z-50 bg-background flex flex-col",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between px-6 py-4 border-b",
                children: [
                    /*#__PURE__*/ _jsxs("h2", {
                        className: "text-lg font-semibold flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                className: "w-5 h-5"
                            }),
                            title
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center gap-2",
                        children: controls
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex-1 min-h-0",
                children: children
            })
        ]
    });
}

//# sourceMappingURL=VisualizationFullscreenOverlay.js.map